const theme = {
    typography: {
        defaultProps: {
            variant: "paragraph",
            color: "black",
            textGradient: false,
            className: "",
        },
    },
    tabsHeader: {
        styles: {
            base: {
                bg: "!bg-transparent",
                bgOpacity: "",
                borderRadius: "rounded-xl",
                gap: "gap-2",
            },
        },
    },
    tab: {
        styles: {
            base: {
                indicator: {
                    borderRadius: "rounded-xl",
                },
                tab: {
                    initial: {
                        bg: "!bg-gray-400",
                        borderRadius: "rounded-xl",
                        fontFamily: "!font-display",
                        fontSize: "!text-sm md:!text-lg",
                        px: "!px-3",
                        py: "!py-1",
                        color: "!text-primary-text",
                    }
                }
            },
        },
    },
};

export default theme;
